// extracted by mini-css-extract-plugin
export default {"IconWrapper":"CartBadge_IconWrapper__Kp3Qe","InCart":"CartBadge_InCart__P+3bL","IconWrapper__Icon":"CartBadge_IconWrapper__Icon__KfEGZ"};